import { useHead } from '@unhead/react';
import { Flex } from 'antd';
import { useTranslation } from 'translations/hooks';

import { SingleCardPageWithFilterCardLayout } from 'business/layout/single-card-page-with-filter-card';
import { SingleGraphReferenceContextProvider } from 'business/providers/graph-reference';
import Routes from 'config/routes';
import { useMediaType } from 'technical/media/hooks';
import { PreviousPageButton } from 'ui/button/previous-page-button';
import { FilterCard } from 'ui/filter-card';

import { IndicatorAnalyzeDisplayContainer } from './components/display-container';
import { IndicatorAnalyzeFilters } from './components/filters';
import { IndicatorAnalyzeHeader } from './components/header';
import { IndicatorAnalyzePrintHeader } from './components/print-header';
import { MobileIndicatorAnalyzePage } from './mobile';
import { IndicatorAnalyzeFiltersProvider } from './providers/filters';
import { IndicatorAnalyseLegendFilterProvider } from './providers/legend-filters';

export const IndicatorAnalyze = () => {
  const { t } = useTranslation();
  const { isMobile } = useMediaType();

  useHead({ title: t('user.menu.sections.reporting.title') });

  if (isMobile) {
    return <MobileIndicatorAnalyzePage />;
  }

  return (
    <SingleGraphReferenceContextProvider>
      <IndicatorAnalyzeFiltersProvider>
        <IndicatorAnalyseLegendFilterProvider>
          <SingleCardPageWithFilterCardLayout
            title={t('pages.manager.indicators.title')}
            header={<IndicatorAnalyzeHeader />}
            footer={
              <Flex justify="center">
                <PreviousPageButton
                  to={Routes.ReportDashboardAnalyze}
                  label="common.to_main_page"
                />
              </Flex>
            }
            printHeader={<IndicatorAnalyzePrintHeader />}
            filters={
              <FilterCard>
                <IndicatorAnalyzeFilters />
              </FilterCard>
            }
          >
            <IndicatorAnalyzeDisplayContainer />
          </SingleCardPageWithFilterCardLayout>
        </IndicatorAnalyseLegendFilterProvider>
      </IndicatorAnalyzeFiltersProvider>
    </SingleGraphReferenceContextProvider>
  );
};
